// extracted by mini-css-extract-plugin
module.exports = {"section":"section--tngdwR9hFh","children":"children--17ebulnEzA","title":"title--25CGr3G8wI"};